import { Injectable, Injector } from "@angular/core";
import { SdkBase } from "../utilities/sdk-base/sdk.base";
import { Observable, catchError, of } from "rxjs";
import { AIResponseResource } from "@models/resource/ai-response.resource";
import { AppConfigService } from "@services/app-config.service";
import { HttpClient } from "@angular/common/http";

@Injectable({ providedIn: 'root' })
export class SmartFeatureSdk extends SdkBase {

	constructor(injector: Injector, private http: HttpClient, private appConfigService: AppConfigService) {
		super(injector);
	}

	public generatePromptTitle(prompt: string, externalAppId: string): Observable<string | null> {
		return this.makeHttpRequest<string>('post', `api2/smart/title`, { "externalAppId": externalAppId, "prompt": prompt }).pipe(
			catchError(() => {
				return of(null);
			}));
	}

	public generateResponse(body: SmartFeaturePromptRequest): Observable<string> {
		return this.makeHttpRequest<string>('post', `api2/smart/docs/`, body);
	}

	public generateResponseContinue(body: SmartFeaturePromptContinueRequest): Observable<string> {
		return this.makeHttpRequest<string>('post', `api2/smart/docs/continue`, body);
	}

	public generatePilotResponse(body: RetrieveAndGenerateRequest): Observable<any | null> {
		return this.makeHttpRequest<any>('post', `api2/smart/pilot/`, body);
	}

	public fetchSummary(body: SmartFeatureSummaryRequest): Observable<void> {
		return this.makeHttpRequest<void>('post', `api2/smart/summary/fetch`, body);
	}

	public getSummary(body: SmartFeatureSummaryRequest): Observable<any> {
		return this.http.post<any>(`${this.appConfigService.getConfig().webApi}/api2/smart/summary`, body);
	}

	public getResponse(workflowKey: string): Observable<AIResponseResource> {
		return this.http.post<AIResponseResource>(`${this.appConfigService.getConfig().webApi}/api2/smart/ai-response`, { workflowKey: workflowKey });
	}
}

export class SmartFeaturePromptRequest {
	externalAppId: string;
	aiModel?: string;
	promptId: string;
	docIds: string[];
}

export class SmartFeaturePromptContinueRequest {
	aiMetadataId: string;
	isRetry: boolean;
}

export class SmartFeatureSummaryRequest {
	externalAppId: string;
	aiModel?: string;
	promptId: string;
	docId?: string;
	reviewSetId?: string;
	reviewOrder?: number;
}

export class RetrieveAndGenerateRequest {
	aiModel: string;
	promptId: string;
}
